document.querySelectorAll('.video-play').forEach((button) => {
  button.addEventListener('click', (e) => {
    const iframe = document.querySelector('.modal-video iframe');
    iframe.src = iframe.src + '?badge=0&autoplay=1&background=0';
  });
});

document.querySelectorAll('.modal-close').forEach((button) => {
  button.addEventListener('click', (e) => {
    // Ensure we are working with the '.modal-close' element, even if a child is clicked
    const modalCloseButton = e.target.closest('.modal-close');

    // Check if the modal close button is found
    if (modalCloseButton) {
      // Get the modal element
      const modal = modalCloseButton.closest('.modal');

      // Only proceed if this is a video modal (has iframe)
      if (modal && modal.querySelector('iframe')) {
        // Get the next sibling of the '.modal-close' element
        const iframeContainer = modalCloseButton.nextElementSibling;
        if (iframeContainer) {
          const iframe = iframeContainer.querySelector('iframe');
          if (iframe) {
            iframe.src = iframe.src.replace(
              '?badge=0&autoplay=1&background=0',
              ''
            ); // Reloads the iframe
          }
        }
      }
      // If no iframe found, silently continue (no console.log needed)
    }
  });
});
